

var els = document.querySelectorAll('.product-slider__container');
for (var i = 0; i < els.length; i++) {
    var pagination = els[i].querySelector(".slids-pagination");
    var nextEl = els[i].querySelector(".slids-next");
    var prevEl = els[i].querySelector(".slids-prev");
    var swiper = new Swiper(els[i], {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 16,
  
        breakpoints: {
          720: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 16,
          },
  
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 16,
          },
        },
        pagination: {
          el: pagination,
          type: "fraction",
        },
  
        navigation: {
          nextEl: ".slids-next",
          prevEl: ".slids-prev",
        },
      });
  }

  